export default __webpack_public_path__ + "static/media/places2.ef8c2ba2.jpg";